import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, ListWrapper } from '../..';
import { DataImportTable } from './DataImportTable';
import {
    cleanRatesRelationSelectAndStore,
    getImportRatesFilterParams,
    getRateListRelationSelect,
} from '../../../middleware';
import Styles from '../../styles/m_itemCardStyles.less';

export const DataImport: React.FC = observer(() => {
    const filterParams = getImportRatesFilterParams();

    return (
        <Catcher>
            <div className={Styles.main}>
                <ListWrapper
                    cleanStore={cleanRatesRelationSelectAndStore}
                    filterParams={filterParams}
                    getRelationSelect={getRateListRelationSelect}
                >
                    <DataImportTable />
                </ListWrapper>
            </div>
        </Catcher>
    );
});
